import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { SearchSchema } from "./-constants";

export const Route = createFileRoute("/_staff/devices/_list/inventory/")({
  validateSearch: zodValidator(SearchSchema),
});
